export default class ButtonData{
    constructor(title, color, isSelete){
        this.title = title
        this.color = color
        this.isSelete = isSelete
    }
}